import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderUpdatePage = lazy(() => import('../views/update/ProviderUpdatePage'));

export function ProviderUpdatePageLazy() {
	return (
		<PageSuspense>
			<ProviderUpdatePage />
		</PageSuspense>
	);
}
